// Tracks the last time each GET endpoint succeeded, so failed-state UI can
// show "last updated" instead of leaving the user with no sense of staleness.
const lastSuccessByUrl = new Map();

export const recordApiSuccess = (url) => {
  if (!url) return;
  lastSuccessByUrl.set(url, Date.now());
};

export const getLastApiSuccess = (url) => lastSuccessByUrl.get(url) || null;

export const generateReferenceId = () =>
  Math.random().toString(36).slice(2, 8).toUpperCase();
